import { render } from "./ContractsPage.vue?vue&type=template&id=4dd394e6&ts=true"
import script from "./ContractsPage?vue&type=script&lang=ts"
export * from "./ContractsPage?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__